import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import * as Ant from "antd";
import { ApolloError, useMutation } from "@apollo/client";
import { useTranslate } from "@bluelibs/x-ui";
import { FrownOutlined, SmileOutlined } from "@ant-design/icons";
import moment from "moment";
import { TransactionsUpdateOne } from "../../mutations/TransactionsUpdateOne";
import dayjs from "dayjs";
const IsTransactionCompletedCheckBox = ({ value, model }) => {
    const t = useTranslate();
    const [modal, setModal] = useState(false);
    const [updateTransaction] = useMutation(TransactionsUpdateOne);
    const handleOnClick = (status) => {
        updateTransaction({
            variables: {
                id: model._id,
                document: {
                    isCompleted: status,
                },
            },
        })
            .then(() => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.transactions.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            if (status) {
                setModal(true);
            }
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    };
    const handleSave = (document) => {
        const completeDate = dayjs(document.completeDate).toDate();
        updateTransaction({
            variables: {
                id: model._id,
                document: {
                    completeDate,
                },
            },
        })
            .then(() => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.transactions.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            setModal(false);
        })
            .catch(() => {
            Ant.notification.error({
                message: t("generics.error"),
                icon: _jsx(FrownOutlined, {}, void 0),
            });
        });
    };
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf("day");
    };
    return (_jsxs(_Fragment, { children: [_jsx(Ant.Checkbox, { type: "checkbox", defaultChecked: value, onChange: (e) => handleOnClick(e.target.checked) }, void 0), _jsx(Ant.Modal, Object.assign({ title: "Basic Modal", open: modal, footer: false, onCancel: () => setModal(false) }, { children: _jsxs(Ant.Form, Object.assign({ onFinish: handleSave, layout: "vertical", requiredMark: "optional" }, { children: [_jsx(Ant.Form.Item, Object.assign({ name: "completeDate", label: t("management.transactions.complete_date"), required: true }, { children: _jsx(Ant.DatePicker, { defaultValue: moment(new Date()), disabledDate: disabledDate, style: { width: "100%" } }, void 0) }), void 0), _jsx(Ant.Form.Item, { children: _jsx(Ant.Button, Object.assign({ type: "primary", htmlType: "submit" }, { children: t("management.transactions.save") }), void 0) }, void 0)] }), void 0) }), void 0)] }, void 0));
};
export default IsTransactionCompletedCheckBox;
